import { render, staticRenderFns } from "./trashCollectAmountCard.vue?vue&type=template&id=6e819aa0&"
import script from "./trashCollectAmountCard.vue?vue&type=script&lang=js&"
export * from "./trashCollectAmountCard.vue?vue&type=script&lang=js&"
import style0 from "./trashCollectAmountCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports